export default function user_roles(state = null, action) {
    switch (action.type) {
        case 'USER_ROLES_SET':
            return action.payload
        default:
            return state
    }
} 